const api = '/api/v1/inquiry.php';
import axios from 'axios';
export const inquiryRepository =  {
    methods: {
        async inquiry(item){
            return  axios.post(api,item)
        },
    }
};

